import { useLanguage } from '../context/LanguageContext';

export default function LanguageToggle({ className = "", variant = "inline" }) {
  const { language, setLanguage } = useLanguage();

  // Floating variant - fixed position in corner
  if (variant === "floating") {
    return (
      <div 
        className="fixed bottom-24 right-6 z-50 flex bg-burns-black/90 backdrop-blur-sm border border-white/20 rounded-full shadow-lg overflow-hidden"
        data-testid="language-toggle-floating"
      >
        <button
          onClick={() => setLanguage('en')}
          className={`px-4 py-2 text-sm font-heading tracking-wide transition-all ${
            language === 'en' 
              ? 'bg-burns-red text-white' 
              : 'text-zinc-400 hover:text-white hover:bg-white/10'
          }`}
          data-testid="lang-en-btn"
        >
          EN
        </button>
        <button
          onClick={() => setLanguage('fr')}
          className={`px-4 py-2 text-sm font-heading tracking-wide transition-all ${
            language === 'fr' 
              ? 'bg-burns-red text-white' 
              : 'text-zinc-400 hover:text-white hover:bg-white/10'
          }`}
          data-testid="lang-fr-btn"
        >
          FR
        </button>
      </div>
    );
  }

  // Inline variant (for nav, headers)
  return (
    <div 
      className={`flex bg-burns-dark/50 border border-white/10 rounded-full overflow-hidden ${className}`}
      data-testid="language-toggle"
    >
      <button
        onClick={() => setLanguage('en')}
        className={`px-3 py-1.5 text-xs font-heading tracking-wide transition-all ${
          language === 'en' 
            ? 'bg-burns-red text-white' 
            : 'text-zinc-400 hover:text-white'
        }`}
      >
        EN
      </button>
      <button
        onClick={() => setLanguage('fr')}
        className={`px-3 py-1.5 text-xs font-heading tracking-wide transition-all ${
          language === 'fr' 
            ? 'bg-burns-red text-white' 
            : 'text-zinc-400 hover:text-white'
        }`}
      >
        FR
      </button>
    </div>
  );
}
